import axios, { type AxiosError } from 'axios';
import { Storage } from 'react-jhipster';

const TIMEOUT = 1 * 60 * 1000;
axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL = SERVER_API_URL;

const setupAxiosInterceptors = onUnauthenticated => {
  const onRequestSuccess = config => {
    const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  };
  const onResponseSuccess = response => response;
  const onResponseError = (err: AxiosError) => {
    const status = err.status || (err.response ? err.response.status : 0);
    {
      /* replaced generated code
    if (status === 401) {
      onUnauthenticated();
    }
    */
    }
    {
      /* start custom code */
    }
    /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
    console.warn(JSON.stringify(err, null, 2));

    if (status === 403 || status === 401) {
      if (err.config.url === 'api/account') {
        onUnauthenticated();
      }
    }
    {
      /* end custom code */
    }
    return Promise.reject(err);
  };
  axios.interceptors.request.use(onRequestSuccess);
  axios.interceptors.response.use(onResponseSuccess, onResponseError);
};

export default setupAxiosInterceptors;
